<template>
  <div>
    <h3 class="verification-details__subtitle">
      {{ 'verification-details.lbl-comments' | globalize }}
    </h3>

    <comments
      :data-source="verification.comments"
      :loading="loading"
      :on-add="onAddComment"
    />
  </div>
</template>

<script>
import { vuexTypes } from '@/vuex'
import { mapGetters } from 'vuex'
import { api } from '@/api'
import Comments from '@/vue/common/comments'
import { ErrorHandler } from '@/js/helpers/error-handler'
import { VerificationRecord } from '@/js/records/entities/verification.record'

export default {
  name: 'verification-comment-form',
  components: {
    'comments': Comments,
  },
  props: {
    verification: {
      type: VerificationRecord,
      required: true,
    },
  },
  data () {
    return {
      loading: false,
    }
  },
  computed: {
    ...mapGetters([vuexTypes.account]),
    ...mapGetters([vuexTypes.accountAddress]),
    currentUser () {
      return {
        ...this.account.general,
        id: this.account.id,
        ethAddress: this.accountAddress,
      }
    },
  },
  methods: {
    async onAddComment (newComment) {
      this.loading = true

      const { comments } = this.verification
      const { currentUser } = this

      currentUser.url = `/users/${currentUser.id}`

      comments.push({
        author: { ...currentUser },
        text: newComment,
        created: new Date().toISOString(),
      })

      const body = JSON.stringify({
        data: {
          type: 'update_verification',
          attributes: {
            comments,
          },
        },
      })
      try {
        const response = await api.patchWithSignature(
          `/verifications/${this.verification.id}`,
          body
        )

        return response.data
      } catch (e) {
        ErrorHandler.processWithoutFeedback(e)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>

</style>
